



import StoreHistoryListComponent from "@/components/admin/storeHistory/storeHistoryListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreHistoryListPage",
  components: {
    StoreHistoryListComponent,
  },
})
export default class StoreHistoryListPage extends Vue {}
